import { Link } from "react-router-dom";
import { useT, useRoute } from "@/i18n";

/**
 * PageHero – consistent intro band for every inner page.
 */
export default function PageHero({ eyebrow, title, image, subtitle }) {
  const t = useT();
  const route = useRoute();
  return (
    <section className="relative w-full h-[60vh] min-h-[440px] overflow-hidden bg-black">
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover opacity-60"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/30 to-black/70" />
      <div className="relative max-w-[1600px] h-full mx-auto px-6 md:px-10 lg:px-14 flex flex-col justify-end pb-16">
        <p className="text-[11px] sm:text-xs uppercase tracking-[0.4em] text-[#C20E1A] font-bold mb-4">
          {eyebrow}
        </p>
        <h1 className="heading-display text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 max-w-2xl text-white/80 text-base sm:text-lg">{subtitle}</p>
        )}
        <nav className="mt-8 text-[11px] uppercase tracking-[0.3em] text-white/60">
          <Link to={route("home")} className="hover:text-white">{t.common.backToHome}</Link> <span className="mx-2">/</span>{" "}
          <span className="text-white">{title}</span>
        </nav>
      </div>
    </section>
  );
}
